// extracted by mini-css-extract-plugin
export default {"bold":"HighlightedNumbersByDecimals_bold__x9JkF","medium":"HighlightedNumbersByDecimals_medium__NRBUe","light":"HighlightedNumbersByDecimals_light__OCx1M"};